import AlertRegular from 'mini-fluent-svg-icons/lib/icons/AlertRegular';
import ArrowCircleLeftRegular from 'mini-fluent-svg-icons/lib/icons/ArrowCircleLeftRegular';
import ArrowCircleRightRegular from 'mini-fluent-svg-icons/lib/icons/ArrowCircleRightRegular';
import ArrowDownRegular from 'mini-fluent-svg-icons/lib/icons/ArrowDownRegular';
import ArrowForwardRegular from 'mini-fluent-svg-icons/lib/icons/ArrowForwardRegular';
import ArrowReplyRegular from 'mini-fluent-svg-icons/lib/icons/ArrowReplyRegular';
import AttachRegular from 'mini-fluent-svg-icons/lib/icons/AttachRegular';
import CalendarCancelRegular from 'mini-fluent-svg-icons/lib/icons/CalendarCancelRegular';
import CalendarCheckmarkRegular from 'mini-fluent-svg-icons/lib/icons/CalendarCheckmarkRegular';
import CalendarEmptyRegular from 'mini-fluent-svg-icons/lib/icons/CalendarEmptyRegular';
import CalendarQuestionMarkRegular from 'mini-fluent-svg-icons/lib/icons/CalendarQuestionMarkRegular';
import CheckboxCheckedSyncRegular from 'mini-fluent-svg-icons/lib/icons/CheckboxCheckedSyncRegular';
import CheckmarkCircleRegular from 'mini-fluent-svg-icons/lib/icons/CheckmarkCircleRegular';
import CheckmarkSquareRegular from 'mini-fluent-svg-icons/lib/icons/CheckmarkSquareRegular';
import ContactCardRegular from 'mini-fluent-svg-icons/lib/icons/ContactCardRegular';
import DoorArrowLeftRegular from 'mini-fluent-svg-icons/lib/icons/DoorArrowLeftRegular';
import FaxRegular from 'mini-fluent-svg-icons/lib/icons/FaxRegular';
import ImportantRegular from 'mini-fluent-svg-icons/lib/icons/ImportantRegular';
import MentionRegular from 'mini-fluent-svg-icons/lib/icons/MentionRegular';
import NotebookRegular from 'mini-fluent-svg-icons/lib/icons/NotebookRegular';
import NotePinRegular from 'mini-fluent-svg-icons/lib/icons/NotePinRegular';
import NoteRegular from 'mini-fluent-svg-icons/lib/icons/NoteRegular';
import SubtractCircleFilled from 'mini-fluent-svg-icons/lib/icons/SubtractCircleFilled';
import ThumbLikeRegular from 'mini-fluent-svg-icons/lib/icons/ThumbLikeRegular';
import VoicemailArrowBackRegular from 'mini-fluent-svg-icons/lib/icons/VoicemailArrowBackRegular';
import VoicemailArrowForwardRegular from 'mini-fluent-svg-icons/lib/icons/VoicemailArrowForwardRegular';
import VoicemailRegular from 'mini-fluent-svg-icons/lib/icons/VoicemailRegular';
import { type PropertyIcons } from '../schema/PropertyIcons';
/**
 * Gets the style of the property icon passed as input
 * Do not include owa-sprites for now since it's currently targeted for consumers.
 * var spriteStyles = require('owa-sprite/dist/styles/mail_sprite.css');
 * @param propertyIcon
 */

export function getPropertyIconName(propertyIcon: PropertyIcons): string {
    switch (propertyIcon) {
        case 35:
            return MentionRegular;
        case 2:
            return AttachRegular;
        case 38:
            return ArrowDownRegular;
        case 1:
            return ImportantRegular;
        case 33:
            return ThumbLikeRegular;
        case 3:
            return ArrowReplyRegular;
        case 4:
            return ArrowForwardRegular;
        case 5:
            return SubtractCircleFilled;
        case 6:
            //return spriteStyles["mail-icon-irm_replied"];
            return SubtractCircleFilled;
        case 7:
            //return spriteStyles["mail-icon-irm_forwarded"];
            return SubtractCircleFilled;
        case 8:
            return VoicemailRegular;
        case 9:
            return VoicemailArrowBackRegular;
        case 10:
            return VoicemailArrowForwardRegular;
        case 11:
            //return spriteStyles["mail-icon-voicemail_irm"];
            return SubtractCircleFilled;
        case 12:
            return FaxRegular;
        case 13:
            return CalendarEmptyRegular;
        case 14:
            //return spriteStyles["mail-icon-event_accepted"];
            return CalendarCheckmarkRegular;
        case 15:
            //return spriteStyles["mail-icon-event_declined"];
            return CalendarCancelRegular;
        case 16:
            //return spriteStyles["mail-icon-event_tentative"];
            return CalendarQuestionMarkRegular;
        case 17:
            return CalendarCancelRegular;
        case 18:
            return ContactCardRegular;
        case 19:
            return CheckmarkSquareRegular;
        case 20:
            return CheckboxCheckedSyncRegular;
        case 21:
            return NotebookRegular;
        case 22:
            return NotePinRegular;
        case 23:
            return NoteRegular;
        case 24:
            // Bug 1752 - culture specific
            return ArrowCircleRightRegular;
        case 25:
            // Bug 1752 - culture specific
            return ArrowCircleLeftRegular;
        case 26:
            // add sprite response_request.png
            return ArrowCircleLeftRegular;
        case 27:
            // add sprite response_approve.png
            return ArrowCircleLeftRegular;
        case 28:
            // add sprite response_reject.png
            return ArrowCircleLeftRegular;
        case 29:
            // Bug 1752 - culture specific
            return DoorArrowLeftRegular;
        case 30:
            return CheckmarkCircleRegular;
        case 31:
            return AlertRegular;
        default:
            throw new Error('No CSS class icon for the given property icon');
    }
}
